var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossThick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6619 5.31543C19.0822 4.89514 19.765 4.89514 20.1853 5.31543C20.6055 5.73573 20.6056 6.41859 20.1853 6.83887L14.0251 13L20.1873 19.1621C20.6075 19.5824 20.6075 20.2653 20.1873 20.6855L20.1853 20.6875C19.9758 20.8946 19.7008 21 19.4255 21C19.1526 21 18.8748 20.8975 18.6628 20.6855L12.5017 14.5234L6.33765 20.6875C6.12811 20.8947 5.85232 21 5.5769 21C5.30409 20.9999 5.02701 20.8973 4.81519 20.6855C4.39489 20.2653 4.39489 19.5824 4.81519 19.1621L10.9773 13L4.81519 6.83887C4.39489 6.41857 4.39489 5.73572 4.81519 5.31543C5.23548 4.89514 5.91833 4.89514 6.33862 5.31543L12.4998 11.4775L18.6619 5.31543Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThick);
export default __webpack_public_path__ + "static/media/cross-thick.ad9321c955c6510c5e70696b3be6bbbb.svg";
export { ForwardRef as ReactComponent };